import React, { Component } from 'react';
import { Modal, Table } from 'antd';
import { connect } from 'dva';
import styles from './index.less';

@connect(({ labelSetting }) => {
  return {
    ...labelSetting,
  };
})
class Order extends Component {
  render() {
    const { showOrderModal, changeOrderVisible, isGroup, dataSource, orderMove } = this.props;

    const columns = [
      {
        title: isGroup ? '名称' : '标签名称',
        dataIndex: isGroup ? 'name' : 'label',
        key: isGroup ? 'name' : 'label',
      },
      {
        title: '操作',
        dataIndex: 'age',
        key: 'age',
        fixed: 'right',
        width: 160,
        render: (text, record, index) => {
          return (
            <>
              <a disabled={index === 0} style={{ marginRight: 15 }} onClick={() => orderMove(record, 'up')} >
                上移
              </a>
              <a disabled={index === dataSource.length - 1} style={{ marginRight: 15 }} onClick={() => orderMove(record, 'down')}>
                下移
              </a>
              <a disabled={index === 0} onClick={() => orderMove(record, 'top')} >置顶</a>
            </>
          );
        },
      },
    ];

    return (
      <Modal
        title="调整顺序"
        visible={showOrderModal}
        centered
        className={styles['order-modal']}
        footer={[]}
        onCancel={() => changeOrderVisible(false)}
      >
        <Table pagination={false} dataSource={dataSource} columns={columns} />
      </Modal>
    );
  }
}

export default Order;
